@if (!!isInitializing) {
  <div class="flex justify-center">
    <p-progressSpinner />
  </div>
}
@if (!isInitializing) {
  <div class="flex flex-col">
    @if (contentText) {
      <p>{{ contentText }}</p>
    }
    <form class="flex flex-col" [formGroup]="formGroup">
      @for (config of formDialogConfigs; track $index) {
        <div class="pb-4 flex flex-col">
          <label
        [ngClass]="{
          'field-required': config.validators?.includes(Validators.required)
        }"
            >{{ config.label }}</label
            >
            @switch (config.type) {
              @case ('dropdown') {
                <p-select
                  appendTo="body"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select"
                  styleClass="w-full"
                  [class.ng-invalid]="isInvalid(config.formControlName)"
                  [filter]="true"
                  [formControlName]="config.formControlName"
                  [options]="config.options"
                  />
                }
                @case ('multiselect') {
                  <p-multiSelect
                    appendTo="body"
                    display="chip"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select"
                    styleClass="w-full"
                    [class.ng-invalid]="isInvalid(config.formControlName)"
                    [formControlName]="config.formControlName"
                    [options]="config.options"
                    [showClear]="true"
                  ></p-multiSelect>
                }
                @case ('input') {
                  <input
                    pInputText
                    styleClass="w-100"
                    maxlength="{{ config.maxLength }} ?? null"
                    [class.ng-invalid]="isInvalid(config.formControlName)"
                    [formControlName]="config.formControlName"
                    />
                    @if (config.charCounter && config.maxLength) {
                      <span class="text-right">
                        {{ formGroup?.get(config.formControlName)?.value?.length || 0 }} / {{ config.maxLength }}
                      </span>
                    }
                  }
                  @case ('auth-input') {
                    <input
                      pInputText
                      styleClass="w-100"
                      [class.ng-invalid]="isInvalid(config.formControlName)"
                      [formControlName]="config.formControlName"
                      (blur)="authService.onBlur($event, formGroup.get(config.formControlName))"
                      (input)="authService.onInput($event, formGroup.get(config.formControlName))"
                      (paste)="authService.onPaste($event, formGroup.get(config.formControlName))"
                      />
                      @if (authService.authInvalid && isInvalid(config.formControlName)) {
                        <small class="p-error">
                          Please enter a valid Authorization Number.
                        </small>
                      }
                      @if (!authFound && previouslySearched === formGroup.get(config.formControlName).value) {
                        <small class="p-error">
                          The Authorization Number requested cannot be found. Please verify you have the correct Authorization Number.
                        </small>
                      }
                    }
                    @case ('text') {
                      <p>{{ config.text }}</p>
                    }
                    @default {
                    }
                  }
                </div>
              }
            </form>
            <div class="flex flex-row gap-2 justify-end items-center my-2">
              <button
                aria-label="Cancel"
                severity="secondary"
                class="w-20"
                label="Cancel"
                pButton
                type="button"
                (click)="cancelClick()"
              ></button>
              @if (!isLoading) {
                <button
                  class="w-20"
                  pButton
                  type="button"
                  [attr.aria-label]="submitLabel"
                  [label]="submitLabel"
                  [disabled]="formGroup.invalid"
                  (click)="submitClick()"
                ></button>
              } @else {
                <p-progressSpinner ariaLabel="loading" styleClass="p-progress-spinner-sm" />
              }
            </div>
          </div>
        }
